import { isValidEmail } from '@studio/helpers/isValidEmail';
import { useSession } from '@studio/storeV2/authentication/session-store';

const useIsEmailUnverified = (): boolean => {
  const { user } = useSession();
  return user?.emailVerified === false && !user.actualCustomer && isValidEmail(user.userName);
};

export default useIsEmailUnverified;
